/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { components } from '@modules/billing-api/v1/types'

export type Budget = components['schemas']['Budget']

export type BudgetConfigurationValues = {
  name: Budget['name']
  amount: Budget['amount']
  scopeType?: Budget['scope_type']
  scopeValues?: Budget['scope_values']
}

export enum BudgetsTableField {
  NAME = 'name',
  ACTIVE = 'active',
  SCOPE = 'scope',
  BALANCE = 'balance',
  ALERTS = 'alerts',
}

export type Costs = components['schemas']['Instances']

export enum ActionType {
  Activate = 'activate',
  Deactivate = 'deactivate',
  Delete = 'delete',
}

export enum ScopeType {
  Organization = 'organization',
  CloudResource = 'cloud_resource',
}

export type ActionError = Record<
  Budget['id'],
  {
    budgetName: string
    type: ActionType
  }
>
